import React, { useRef, useEffect } from 'react';

// حقل رمز تحقق بخانات مستقلة (6 أرقام) مع تكبير/نبض لطيف عند إدخال كل رقم
export default function OtpBoxInput({ length = 6, value, onChange, autoFocus, testIdPrefix = 'otp', error }) {
  const refs = useRef([]);
  const digits = (value || '').split('').concat(Array(length).fill('')).slice(0, length);

  useEffect(() => {
    if (autoFocus) refs.current[0]?.focus();
  }, [autoFocus]);

  const setDigit = (idx, raw) => {
    const clean = raw.replace(/\D/g, '');
    const next = digits.slice();
    next[idx] = clean ? clean.slice(-1) : '';
    onChange(next.join(''));
    if (clean && idx < length - 1) refs.current[idx + 1]?.focus();
  };

  const handleKeyDown = (idx, e) => {
    if (e.key === 'Backspace' && !digits[idx] && idx > 0) refs.current[idx - 1]?.focus();
  };

  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, length);
    if (pasted) {
      e.preventDefault();
      onChange(pasted);
      refs.current[Math.min(pasted.length, length - 1)]?.focus();
    }
  };

  return (
    <div dir="ltr" className="flex items-center justify-center gap-2" data-testid={`${testIdPrefix}-group`}>
      {digits.map((d, i) => (
        <div key={i} className="relative h-14 w-11 sm:h-16 sm:w-12">
          <input
            ref={(el) => (refs.current[i] = el)}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={d}
            onChange={(e) => setDigit(i, e.target.value)}
            onKeyDown={(e) => handleKeyDown(i, e)}
            onPaste={handlePaste}
            data-testid={`${testIdPrefix}-digit-${i}`}
            className="peer absolute inset-0 z-10 h-full w-full cursor-text bg-transparent text-center text-2xl text-transparent caret-transparent outline-none"
          />
          <span
            key={d ? `f-${i}-${d}` : `e-${i}`}
            className={`otp-box-pop pointer-events-none absolute inset-0 flex items-center justify-center rounded-xl border-2 text-2xl font-black transition-colors peer-focus:border-teal-500 peer-focus:ring-2 peer-focus:ring-teal-100 ${
              error ? 'border-red-300 bg-red-50 text-red-600' : d ? 'border-teal-500 bg-teal-50 text-[#0A192F]' : 'border-slate-200 bg-slate-50 text-slate-400'
            }`}
          >
            {d || ''}
          </span>
        </div>
      ))}
    </div>
  );
}
